import { render } from "./EditSliderTestimoniHome.vue?vue&type=template&id=7cce324a&scoped=true"
import script from "./EditSliderTestimoniHome.vue?vue&type=script&lang=js"
export * from "./EditSliderTestimoniHome.vue?vue&type=script&lang=js"

import "./EditSliderTestimoniHome.vue?vue&type=style&index=0&id=7cce324a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cce324a"]])

export default __exports__